import React from "react";
import Footer from "../../../Components/Footer/footer";
import { Helmet } from "react-helmet-async";

const WarrantyPdfPage = () => (
  <div className="container-xl">
    <Helmet>
      <title>Warranty Details | Kryzen Biotech Pvt Ltd</title>
      <meta
        name="description"
        content="Explore warranty coverage for GI Pipe, Polyfilm, Shade Net, Insect Net, and more offered by Kryzen Biotech Pvt Ltd."
      />
      <meta
        name="keywords"
        content="Warranty, GI Pipe, Polyfilm, Shade Net, Insect Net, Kryzen Biotech, Hydroponics Warranty, Greenhouse Components"
      />
      <meta name="author" content="Kryzen Biotech Pvt Ltd" />
      <link rel="canonical" href="https://alpha.kryzen.com/warranty" />
    </Helmet>
    <h1 className="fs-12 m-5 text-center">
      <b>Warranty Details</b>
    </h1>

    {/* <LazyImageComponent
        width="100%"
        src="/warrantyDocument.pdf"
        alt="Document is not visible"
        style={{ height:"550px",marginBottom:"60px" }}
      ></LazyImageComponent> */}
    <div className="card mt-2">
      <div className="card-body">
        <div className="mb-5">
          <h3>WARRANTY FOR GI PIPE STRUCTURE (CEA ONLY)</h3>
          <p>
            <b>1. Warranty Period: 15 Years</b>
          </p>
          <p>
            <b>2. Scope of Warranty:</b> This warranty covers the GI pipe
            structure provided by Kryzen Biotech Pvt Ltd and is valid for 15
            years from the date of installation, provided the installation is
            performed by an authorized professional and under normal operating
            conditions.
          </p>
          <p>
            <b>3. What is Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Manufacturing Defects: The warranty covers any
            manufacturing defects in the GI pipe structure, including defects in
            material or workmanship
          </p>
          <p>
            <b>4. What is Not Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Natural Disasters: Damage caused by cyclones,
            heavy winds, storms, or other extreme weather events.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Heavy Rain Damage: Damage due to excessive or
            prolonged exposure to heavy rain or flooding.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. External Damage: Damage caused by third-party
            actions, accidents, vandalism, or misuse.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. Improper Maintenance: Any damage resulting from
            improper maintenance, alteration, or handling of the GI pipe
            structure.
          </p>
        </div>

        <div className="mb-5">
          <hr></hr>
          <h3>WARRANTY FOR GI GUTTER</h3>
          <p>
            <b>1. Warranty Period: 6 Year</b>
          </p>
          <p>
            <b>2. Scope of Warranty:</b> This warranty covers the GI Gutter
            provided by Kryzen Biotech Pvt Ltd and is valid for a period of 6
            years from the date of installation, provided that the installation
            is performed according to the manufacturer’s instructions and under
            normal operating conditions.
          </p>
          <p>
            <b>3. What is Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Manufacturing Defects: The warranty covers
            defects in materials or workmanship arising from the manufacturing
            process.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. General Defects: The warranty also covers any
            general defects related to the GI Gutter’s structure or
            functionality that result from flaws in design or production.
          </p>
          <p>
            <b>4. What is Not Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Natural Disasters: Damage caused by cyclone,
            heavy winds, storms, or other extreme weather events.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Heavy Rain Damage: Damage due to excessive or
            prolonged exposure to heavy rain or flooding.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. Physical Damage: Any harm caused by cutting,
            chopping, burning, or other mechanical actions
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. Water Blockage: Damage caused by water blockage
            or poor drainage due to improper installation, design flaws, or
            neglect of gutter maintenance.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;e. External Damage: Damage caused by third-party
            actions, accidents, or misuse.
          </p>
        </div>
        <div className="mb-5">
          <hr></hr>
          <h3>WARRANTY FOR SHADENET</h3>
          <p>
            <b>1. Warranty Period: 3 Years</b>
          </p>
          <p>
            <b>2. Scope of Warranty:</b> This warranty covers the Shadenet
            provided by Kryzen Biotech Pvt Ltd and is valid for a period of 3
            years from the date of purchase or installation, provided that the
            installation and use are in accordance with the manufacturer’s
            guidelines and under normal operating conditions.
          </p>
          <p>
            <b>3. What is Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Manufacturing Defects: The warranty covers
            defects in materials or workmanship that arise from the
            manufacturing process.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Tearing and Patching: The warranty covers any
            tearing or patching defects that occur under normal use.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. Decolorization: The warranty covers
            decolorization or fading due to the inherent material properties of
            the Shadenet.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. General Defects: The warranty also covers any
            general structural defects that arise from flaws in design or
            production.
          </p>
          <p>
            <b>4. What is Not Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Natural Disasters: Damage caused by cyclone,
            heavy winds, storms, or other extreme weather events
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Heavy Rain Damage: Damage due to excessive or
            prolonged exposure to heavy rain or flooding.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. Physical Damage: Any harm caused by cutting,
            chopping, burning, or other mechanical actions.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. External Damage: Damage caused by third-party
            actions, accidents, or misuse.
          </p>
        </div>
        <div className="mb-5">
          <hr></hr>
          <h3>WARRANTY FOR INSECT NET</h3>
          <p>
            <b>1. Warranty Period: 3 Years</b>
          </p>
          <p>
            <b>2. Scope of Warranty:</b> This warranty covers the Insect Net
            provided by Kryzen Biotech Pvt Ltd and is valid for a period of 5
            years from the date of purchase or installation, provided that the
            installation and usage follow the manufacturer’s guidelines and are
            under normal operating conditions.
          </p>
          <p>
            <b>3. What is Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Manufacturing Defects: The warranty covers
            defects in materials or workmanship arising from the manufacturing
            process.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Tearing and Patching: The warranty covers
            tearing or patching defects that occur under normal use
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. Decolorization: The warranty covers
            decolorization or fading due to material properties.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. General Defects: The warranty also covers any
            general defects in the insect net’s structure or functionality
            resulting from design or production flaws.
          </p>
          <p>
            <b>4. What is Not Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Natural Disasters: Damage caused by cyclone,
            heavy winds, storms, or other extreme weather events.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Heavy Rain Damage: Damage due to excessive or
            prolonged exposure to heavy rain or flooding.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. Physical Damage: Any harm caused by cutting,
            chopping, burning, or other mechanical actions.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. External Damage: Damage caused by third-party
            actions, accidents, or misuse.
          </p>
        </div>
        <div className="mb-5">
          <hr></hr>
          <h3>WARRANTY FOR ALUMINIUM NET</h3>
          <p>
            <b>1. Warranty Period: 3 Year</b>
          </p>
          <p>
            <b>2. Scope of Warranty:</b> This warranty covers the Aluminium Net
            provided by Kryzen Biotech Pvt Ltd and is valid for a period of 6
            years from the date of purchase or installation, provided that the
            installation and usage are in accordance with the manufacturer’s
            instructions and under normal operating conditions.
          </p>
          <p>
            <b>3. What is Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Manufacturing Defects: The warranty covers
            defects in materials or workmanship that arise from the
            manufacturing process.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Tearing and Patching: The warranty covers any
            tearing or patching defects that occur under normal use.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. Decolorization: The warranty covers
            decolourization or fading due to the inherent material properties.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. General Defects: The warranty also covers any
            general defects related to the structure or functionality of the
            Aluminium Net arising from design or production flaws.
          </p>
          <p>
            <b>4. What is Not Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Natural Disasters: Damage caused by cyclone,
            heavy winds, storms, or other extreme weather events.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Heavy Rain Damage: Damage due to excessive or
            prolonged exposure to heavy rain or flooding.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. Physical Damage: Any harm caused by cutting,
            chopping, burning, or other mechanical actions.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. External Damage: Damage caused by third-party
            actions, accidents, or misuse.
          </p>
        </div>

        <div className="mb-5">
          <hr></hr>
          <h3>WARRANTY FOR PLUMBING MATERIAL</h3>
          <p>
            <b>1. Warranty Period: 1 Year</b>
          </p>
          <p>
            <b>2. Scope of Warranty:</b> This warranty covers the Water Tank
            provided by Kryzen Biotech Pvt Ltd and is valid for a period of 10
            years from the date of purchase or installation, provided that the
            installation and usage are in accordance with the manufacturer’s
            instructions and under normal operating conditions.
          </p>
          <p>
            <b>3. What is Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Manufacturing Defects: The warranty covers
            defects in materials or workmanship that arise from the
            manufacturing process.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Tearing and Patching: The warranty covers any
            tearing or patching defects that occur under normal use.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. Decolorization: The warranty covers
            decolorization or fading due to the inherent material properties.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. General Defects: The warranty also covers any
            general defects related to the structure or functionality of the
            Plumbing Material arising from design or production flaws.
          </p>
          <p>
            <b>4. What is Not Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Natural Disasters: Damage caused by cyclones,
            heavy winds, storms, or other extreme weather events.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Heavy Rain Damage: Damage due to excessive or
            prolonged exposure to heavy rain or flooding.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. Physical Damage: Any harm caused by cutting,
            chopping, burning, or other mechanical actions.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. External Damage: Damage caused by third-party
            actions, accidents, or misuse.
          </p>
        </div>
        <div className="mb-5">
          <hr></hr>
          <h3>WARRANTY FOR FOGGER MOTOR</h3>
          <p>
            <b>1. Warranty Period: 1 Year</b>
          </p>
          <p>
            <b>2. Scope of Warranty:</b> This warranty covers the Fogger Motor
            provided by Kryzen Biotech Pvt Ltd and is valid for a period of 1
            year from the date of purchase or installation, provided that the
            installation and usage are in accordance with the manufacturer’s
            instructions and under normal operating conditions. 3. What is
            Covered:
          </p>
          <p>
            <b>3. What is Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Manufacturing Defects: The warranty covers
            defects in materials or workmanship that arise from the
            manufacturing process.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Tearing and Patching: The warranty covers any
            tearing or patching defects that occur under normal use.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. Decolorization: The warranty covers
            decolorization or fading due to the inherent material properties.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. General Defects: The warranty also covers any
            general defects related to the structure or functionality of the
            Fogger Motor arising from design or production flaws.
          </p>
          <p>
            <b>4. What is Not Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Natural Disasters: Damage caused by cyclones,
            heavy winds, storms, or other extreme weather events.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Heavy Rain Damage: Damage due to excessive or
            prolonged exposure to heavy rain or flooding.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. Physical Damage: Any harm caused by cutting,
            chopping, burning, or other mechanical actions.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. External Damage: Damage caused by third-party
            actions, accidents, or misuse.
          </p>
        </div>
        <div className="mb-5">
          <hr></hr>
          <h3>WARRANTY FOR RESERVOIR MOTOR</h3>
          <p>
            <b>1. Warranty Period: 1 Year</b>
          </p>
          <p>
            <b>2. Scope of Warranty:</b> This warranty covers the Reservoir
            Motor provided by Kryzen Biotech Pvt Ltd and is valid for a period
            of 1 year from the date of purchase or installation, provided that
            the installation and usage are in accordance with the manufacturer’s
            instructions and under normal operating conditions
          </p>
          <p>
            <b>3. What is Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Manufacturing Defects: The warranty covers
            defects in materials or workmanship that arise from the
            manufacturing process.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Tearing and Patching: The warranty covers any
            tearing or patching defects that occur under normal use.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. Decolorization: The warranty covers
            decolorization or fading due to the inherent material properties.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. General Defects: The warranty also covers any
            general defects related to the structure or functionality of the
            Reservoir Motor arising from design or production flaws.
          </p>
          <p>
            <b>4. What is Not Covered:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;a. Natural Disasters: Damage caused by cyclones,
            heavy winds, storms, or other extreme weather events.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;b. Heavy Rain Damage: Damage due to excessive or
            prolonged exposure to heavy rain or flooding.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;c. Physical Damage: Any harm caused by cutting,
            chopping, burning, or other mechanical actions.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;d. External Damage: Damage caused by third-party
            actions, accidents, or misuse.
          </p>
        </div>
        <hr></hr>
        <h3 className="mb-3">Warranty Claim Process:</h3>
        <div className="mb-5">
          <p>
            <b>To file a warranty claim, the following steps must be taken:</b>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;1. Contact Us: Reach out to Kryzen Biotech Pvt Ltd
            at contact@kryzen.com to report the issue.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;2. Inspection: A qualified technician will inspect
            the GI pipe structure to verify the defect or damage.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;3. Claim Approval: If the warranty claim is
            validated, the defective parts will be repaired or replaced at no
            additional cost. In cases where replacement is not possible, a
            refund may be provided, at the discretion of Kryzen Biotech Pvt Ltd.
          </p>
        </div>
        <div className="mb-5">
          <hr></hr>
          <h3>Exclusions:</h3>
          <p>
            &nbsp;&nbsp;&nbsp;● The warranty does not cover the cost of
            installation or reinstallation.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;● Damages caused by third-party modifications or
            repairs not authorized by Kryzen Biotech Pvt Ltd will not be
            covered.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;● If the customer has not completed the farm
            operational training then the warranty claim will not be covered.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;● If the damage is caused because of wrong
            handling or inappropriate use other then instruction or guidelines
            will not be covered.
          </p>
        </div>
        <div className="mb-5">
          <hr></hr>
          <h3>Limitation of Liability:</h3>
          <p>
            The liability of Kryzen Biotech Pvt Ltd is limited to the repair or
            replacement of the defective GI pipe structure as outlined above.
            Kryzen Biotech Pvt Ltd shall not be liable for any consequential,
            incidental, or indirect damages resulting from the use or inability
            to use the product
          </p>
        </div>
        <div className="mb-5">
          <hr></hr>
          <p>
            This warranty document serves as an assurance of the quality and
            reliability of our GI pipe structures and aims to provide peace of
            mind to our customers.
          </p>
        </div>
      </div>
    </div>
    <br></br>
    <Footer />
  </div>
);

export default WarrantyPdfPage;
